module.exports = __webpack_public_path__ + "static/media/Sentient_CombatZone.f9874802.gif";